import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { trackingSetSpaceID } from '../../operations/tracking_operations';
import {
  applySpaceHtmlHeadChanges,
  applySpaceWhiteLabelRules,
} from '../../services/spaces';
import { addAppStoreSmartBannerTags } from '../../services/app_stores';
import {
  useGetCurrentSpaceMembershipQuery,
  useGetUserProfileQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { userIsCreator } from '../../services/users';
import { SPACE_REFRESH_INTERVAL_SECONDS } from '../../services/end_user_published_resources';
import { useGetPublicSpaceQuery } from '../../app/smorgAppSyncGraphQLApi';

const ThemeChangeListener = () => {
  const endUserDesiredSpaceID = useSelector(
    (state) => state.whiteLabel.endUserDesiredSpaceID,
  );

  const { data: userProfile } = useGetUserProfileQuery();

  const isSmorgStudio = userIsCreator(userProfile);

  const { data: currentSpaceMembership } = useGetCurrentSpaceMembershipQuery(
    undefined,
    {
      skip: !userProfile || isSmorgStudio,
    },
  );

  const actualSpaceID =
    endUserDesiredSpaceID || currentSpaceMembership?.spaceID;

  const { data: currentSpace } = useGetPublicSpaceQuery(actualSpaceID, {
    skip: !actualSpaceID,
    refetchOnMountOrArgChange: SPACE_REFRESH_INTERVAL_SECONDS,
  });

  useEffect(() => {
    if (!actualSpaceID) {
      return;
    }
    console.log(`ThemeChangeListener: ${actualSpaceID}`);
    trackingSetSpaceID(actualSpaceID);

    if (!currentSpace) {
      return;
    }

    if (currentSpace.whiteLabelElements) {
      applySpaceWhiteLabelRules(currentSpace.whiteLabelElements);
    } else {
      applySpaceWhiteLabelRules(null);
    }

    if (currentSpace.title && currentSpace.whiteLabelElements?.faviconImages) {
      applySpaceHtmlHeadChanges(
        currentSpace.title,
        currentSpace.whiteLabelElements?.faviconImages,
      );
    }

    if (currentSpace.appStoreLinks) {
      addAppStoreSmartBannerTags(currentSpace.appStoreLinks);
    }
  }, [
    actualSpaceID,
    currentSpaceMembership?.spaceID,
    currentSpace?.title,
    currentSpace?.whiteLabelElements,
    currentSpace?.appStoreLinks,
    currentSpace,
  ]);

  return null;
};

export default ThemeChangeListener;
